import type { FC } from "react";

import DiabetModal from "@/components/modals/profil-risk/diabet-modal";
import GeneticModal from "@/components/modals/profil-risk/genetic-modal";
import SmokingModal from "@/components/modals/profil-risk/smoking-modal";
import StressModal from "@/components/modals/profil-risk/stress-modal";
import ToothbrushModal from "@/components/modals/profil-risk/toothbrush-modal";
import type { Patient } from "@/types/api/patient";
import type { Risk } from "@/utils/patient";

export type RiskUpdateModalProps = {
  riskModalOpen: Risk | "none";
  setRiskModalOpen: React.Dispatch<React.SetStateAction<Risk | "none">>;
  patient: Patient;
};

const RiskUpdateModal: FC<RiskUpdateModalProps> = ({
  riskModalOpen,
  setRiskModalOpen,
  patient,
}) => {
  switch (riskModalOpen) {
    case "smoking":
      return (
        <SmokingModal
          riskModalOpen={riskModalOpen}
          setRiskModalOpen={setRiskModalOpen}
          patient={patient}
        />
      );
    case "geneticTendency":
      return (
        <GeneticModal
          riskModalOpen={riskModalOpen}
          setRiskModalOpen={setRiskModalOpen}
          patient={patient}
        />
      );
    case "toothbrush":
      return (
        <ToothbrushModal
          riskModalOpen={riskModalOpen}
          setRiskModalOpen={setRiskModalOpen}
          patient={patient}
        />
      );
    case "diabetic":
      return (
        <DiabetModal
          riskModalOpen={riskModalOpen}
          setRiskModalOpen={setRiskModalOpen}
          patient={patient}
        />
      );
    case "stress":
      return (
        <StressModal
          riskModalOpen={riskModalOpen}
          setRiskModalOpen={setRiskModalOpen}
          patient={patient}
        />
      );
    case "none":
      return null;
  }
};

export default RiskUpdateModal;
